export default "__VITE_ASSET__BzoP2iZM__"